interface SurveyQuestion {
  id: string;
  question: string;
  subtext?: string;
  type: 'boolean' | 'choice' | 'informational' | 'text input';
  options?: string[];
  dependsOn?: {
    questionId: string;
    answer: boolean | string | string[];
  };
  promptInputForOther?: boolean; // If true, prompt for input if "Other" is selected in options
  multipleChoice?: boolean; // If true, allows multiple selections for choice questions
}

/**
 
What's the point of this survey?

1. collect stats from people who use bidets to sway people who don't use bidets
  -> So, what are the stats we'd like?
2. figure out why people don't use bidets, what's stopping them, and if there's nothing actually stopping them, convince them to go for it
3. track the progress of bidet adoption (+ sell reports to bidet resellers and manufacturers)
4. engage with potential customers and stir the pot to increase bidet awareness and discussion. it's a network effect thing. all you have to do is nudge people in the direction of being gross for not having one, then no one will want to be the only one without a bidet


Pointless questions:
- Would you like getting a bidet+installation as a gift?

 */

export const surveyQuestions: SurveyQuestion[] = [
  // basic demographics
  {
    id: 'location',
    question: 'Where in New York do you live?',
    subtext: 'Borough & cross streets (e.g. "Brooklyn, 5th Ave & 3rd St")',
    type: 'text input',
  },
  {
    id: 'originLocation',
    question: 'Where are you from originally?',
    subtext: 'Be as specific as you want (e.g. "Cape Town, South Africa")',
    type: 'text input',
  },
  {
    id: 'age',
    question: 'What is your age?',
    type: 'choice',
    options: [
      'Under 18',
      '18-24',
      '25-34',
      '35-44',
      '45-54',
      '55-64',
      '65 or older',
      'Prefer not to say',
    ],
  },

  // get on the same page
  {
    id: 'regularlyUseBidet',
    question: 'Do you regularly use bidets?',
    subtext: 'Regularly means at least once a week on average',
    type: 'boolean',
  },
    // yes?
    {
      id: 'whatKindOfBidet',
      question: 'What kind of bidet do you use?',
      type: 'choice',
      options: [
        'Standalone bidet (separate fixture)',
        'Bidet toilet seat (replaces toilet seat)',
        'Bidet attachment (goes under toilet seat)',
        'Handheld bidet sprayer',
        'Other',
      ],
      dependsOn: {
        questionId: 'regularlyUseBidet',
        answer: true,
      },
      promptInputForOther: true,
    },
    {
      id: 'coldWaterOrNone',
      question: 'Would you rather use a bidet with cold water or not use a bidet at all?',
      subtext: 'Would you still use a bidet if it only used cold water?',
      type: 'choice',
      options: [
        'Cold water is fine',
        'Not at all (warm water only!)'
      ],
      dependsOn: {
        questionId: 'regularlyUseBidet',
        answer: true,
      },
    },

    // no?
    {
      id: 'knowBidet',
      question: 'Do you know what a bidet is?',
      type: 'boolean',
      dependsOn: {
        questionId: 'regularlyUseBidet',
        answer: false,
      },
    },
      // no?
      {
        id: 'bidetExplanation',
        question: 'A bidet is a bathroom fixture that cleans your bottom with water instead of toilet paper. Most of the civilized world uses them. They are faster, more hygienic (completely clean instead of partially clean) and comfortable than toilet paper. Bidets are amazing! Any questions?',
        type: 'informational',
        dependsOn: {
          questionId: 'knowBidet',
          answer: false,
        },
      },
      // yes?
      {
        id: 'triedBidet',
        question: 'Have you ever tried a bidet?',
        type: 'boolean',
        dependsOn: {
          questionId: 'knowBidet',
          answer: true,
        },
      },
        // yes?
        {
          id: 'whyNoBidet',
          question: 'You know what a bidet is and you\'ve tried one, but you don\'t use them regularly. Is there a particular reason why not?',
          type: 'choice',
          options: [
            'No reason, just don\'t use them',
            'Cost concerns',
            'Installation concerns',
            'Space constraints',
            'Don\'t like the feeling',
            'Prefer to use moist wipes',
            'Don\'t mind being only partially clean',
            'Other',
          ],
          dependsOn: {
            questionId: 'triedBidet',
            answer: true,
          },
          promptInputForOther: true,
          multipleChoice: true,
        },
          // cost concerns, space constraints
          {
            id: 'estimatedCost',
            question: 'How much do you think it costs to get a bidet in your toilet at home right now?',
            type: 'choice',
            options: ['Less than $50', '$50-$100', '$100-$200', '$200-$500', 'More than $500'],
            dependsOn: {
              questionId: 'whyNoBidet',
              answer: ['Cost concerns', 'Space constraints'],
            },
          },
          // installation 
          {
            id: 'wouldGetInstallation',
            question: 'If you could easily get a bidet installed for under $100, would you do it?',
            type: 'boolean',
            dependsOn: {
              questionId: 'whyNoBidet',
              answer: 'Installation concerns',
            },
          },
            // why not? 
            {
              id: 'whyNotGetInstallation',
              question: 'Why not?',
              type: 'choice',
              options: [
                'I prefer to install it myself',
                'I don\'t want to deal with my landlords, co-op board, or building management',
                'Still too expensive',
                'Other'
              ],
              dependsOn: {
                questionId: 'wouldGetInstallation',
                answer: false,
              },
              promptInputForOther: true,
            },

  // // general question
  // {
  //   id: 'giveAsAGift',
  //   question: 'Would you feel weird about giving a bidet/installation as a gift?',  
  //   type: 'boolean',
  // },
  
  // // general question (would be interesting to see the split here between people who use bidets and those who don't)
  // {
  //   id: 'hypotheticalStopUsingBathroom',
  //   question: 'If technology existed that could completely eliminate the need to use the bathroom, would you use it?',  
  //   type: 'boolean',
  // },
];


